import { AiGeneratingPendingByFile } from './AiGeneratingPendingByFile';
import { AiGeneratingPendingByQuery } from './AiGeneratingPendingByQuery';
import { AiGeneratingPendingByWebsite } from './AiGeneratingPendingByWebsite';
import { AiGeneratingPendingByYoutube } from './AiGeneratingPendingByYoutube';

export const AiGeneratingPending = {
  ByQuery: AiGeneratingPendingByQuery,
  ByFile: AiGeneratingPendingByFile,
  ByYoutube: AiGeneratingPendingByYoutube,
  ByWebsite: AiGeneratingPendingByWebsite,
};
